import { render, staticRenderFns } from "./showTopicsInfo.vue?vue&type=template&id=09b25f52&scoped=true&"
import script from "./showTopicsInfo.vue?vue&type=script&lang=js&"
export * from "./showTopicsInfo.vue?vue&type=script&lang=js&"
import style0 from "./showTopicsInfo.vue?vue&type=style&index=0&id=09b25f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b25f52",
  null
  
)

export default component.exports